/**
 * SchoolsPage — het scholenregister beheren.
 *
 * WAAROM DEZE ROUTE BESTAAT
 *
 * De verificatie van een leerkracht rust op één gegeven: bij welke school hoort
 * hij? Zolang die naam vrije tekst was, kon een beheerder hem niet natrekken en
 * was goedkeuren een handeling die eruitzag als een controle. Dit scherm keert
 * de volgorde om: wij nemen een school op nadat de verwerkersovereenkomst rond
 * is, en een leerkracht kiest daaruit.
 *
 * WAAROM AANVRAGEN BOVEN HET REGISTER STAAN — zie SchoolRequestsPanel.
 */

import React, { useCallback, useEffect, useState } from 'react';
import { PageLayout } from '../../shared/PageLayout';
import { SchoolRequestsPanel } from './schools/SchoolRequestsPanel';
import { SchoolRegistryPanel } from './schools/SchoolRegistryPanel';
import { listAllSchools, listSchoolRequests, type School, type SchoolRequest } from '../../../data/supabase/schoolRegistry';
export function SchoolsPage() {
  const [schools, setSchools] = useState<School[]>([]);
  const [requests, setRequests] = useState<SchoolRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [schoolsError, setSchoolsError] = useState<string | null>(null);
  const [requestsError, setRequestsError] = useState<string | null>(null);
  const load = useCallback(async () => {
    setLoading(true);
    // Beide tegelijk: ze zijn onafhankelijk, en de aanvragenlijst heeft het
    // register nodig om suggesties te kunnen doen.
    const [s, r] = await Promise.all([listAllSchools(), listSchoolRequests()]);
    // Bij een fout blijft de bestaande lijst staan in plaats van leeg te worden.
    // Een leeg register en een mislukte query zien er identiek uit, en dan maakt
    // een beheerder een school aan die er al staat.
    if (s.ok) {
      setSchools(s.schools);
      setSchoolsError(null);
    } else {
      setSchoolsError(s.message ?? 'Het register kon niet worden opgehaald.');
    }
    if (r.ok) {
      setRequests(r.requests);
      setRequestsError(null);
    } else {
      setRequestsError(r.message ?? 'De aanvragen konden niet worden opgehaald.');
    }
    setLoading(false);
  }, []);
  useEffect(() => {
    void load();
  }, [load]);
  return <PageLayout title="Scholen" description="Het register waaruit een leerkracht zijn school kiest, en de aanvragen die op een beslissing wachten" data-id="element-7397" data-mp="nlzp6jttxl0j">
      <div className="space-y-5" data-id="element-7398" data-mp="dr7r7ewc4w58">
        <SchoolRequestsPanel requests={requests} schools={schools} loading={loading} error={requestsError} onChanged={() => void load()} data-id="element-7399" data-mp="dqg6x086uku9" />
        <SchoolRegistryPanel schools={schools} loading={loading} error={schoolsError} onChanged={() => void load()} data-id="element-7400" data-mp="16ekejrabl7zl" />
      </div>
    </PageLayout>;
}